<template>
  <div>
    <h1 class="title">{{ $t('page.top') }}</h1>

    <div>
      <h2 class="title is-4">{{ $t('page.Services') }}</h2>
      <service-links
        :services="services"
      ></service-links>
    </div>

  </div>
</template>
<script>
import { Service } from '@/api'
import ServiceLinks from '@/components/organisms/ServiceLinks'

export default{
  name: 'Top',

  components: {
    ServiceLinks,
  },

  data(){
    return {
      services: [],
    }
  },

  computed: {
  },

  async created() {
    await this.setServices()
  },

  methods: {
    async setServices(params = {}) {
      const paramsCopied = { ...params }
      this.$store.dispatch('setLoading', true)
      try {
        const res = await Service.get('', paramsCopied, this.userToken)
        this.$store.dispatch('setLoading', false)
        this.services = res
      } catch (err) {
        console.log(err);//!!!!!!
        this.$store.dispatch('setLoading', false)
        this.handleApiError(err, this.$t('msg["Failed to get data from server"]'))
      }
    },
  }
}
</script>

